export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://rememberqr.online';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;